import { render, staticRenderFns } from "./tkjl.vue?vue&type=template&id=44a17a3d&"
import script from "./tkjl.vue?vue&type=script&lang=js&"
export * from "./tkjl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports